(function (angular) {
    'use strict';

    angular.module('shared')
        .directive('badgeCount', ["$state", "badgeService", function ($state, badgeService) {

            return ({
                link: link,
                restrict: "E",
                templateUrl: "shared/badge/directive.badge.html",
            });

            // I bind the JavaScript events to the view-model.
            function link(scope, element, attributes) {
                scope.count = 0;
                scope.$watch(badgeService.getCount, handleBadgeChange);
                // ---
                // PRIVATE METHODS.
                // ---
                // I handle title changes and update the DOM accordingly.
                function handleBadgeChange(newCount) {
                    scope.count = newCount;
                }

                /**
                 * Navigate to chat from the global badge, unless we are already in chat ...
                 */
                scope.navigate = function (e) {

                    e.preventDefault();
                    e.stopPropagation();

                    if ($state.current.name.indexOf("main.apiSpace.chat2.chat") !== 0) {
                        $state.go("main.apiSpace.chat2.chat");
                    }
                }

            }

        }]);
})(window.angular);
